import { render, staticRenderFns } from "./CF7MaterialConsulta.vue?vue&type=template&id=25cdfaf7&scoped=true&"
import script from "./CF7MaterialConsulta.vue?vue&type=script&lang=js&"
export * from "./CF7MaterialConsulta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cdfaf7",
  null
  
)

export default component.exports